import { Column, Entity, PrimaryGeneratedColumn, VersionColumn, UpdateDateColumn, CreateDateColumn } from "typeorm";

@Entity('employee_leaves')
export class EmployeeLeaves {

    @PrimaryGeneratedColumn('increment', { name: 'employee_leaves_id' })
    employeeLeavesId: number;

    @Column('int', {
        nullable: false,
        name: 'employee_id'
    })
    employeeId: number;

    @Column('varchar', {
        nullable: false,
        length: 40,
        name: 'year'
    })
    year: string;

    @Column('int', {
        nullable: false,
        name: 'type_of_leave'
    })
    typeOfLeave: number;

    @Column('int', {
        nullable: false,
        name: 'leaves_alloted'
    })
    leavesAlloted: number;

    @Column('int', {
        nullable: false,
        name: 'leaves_used'
    })
    leavesUsed: number;


    @Column('int', {
        nullable: false,
        name: 'leaves_available'
    })
    leavesAvailable: number;

    @Column('int', {
        nullable: false,
        name: 'status'
    })
    status: number;

    @Column('datetime', {
        nullable: true,
        name: 'date_time'
    })
    dateTime: Date;

    @Column('boolean', {
        nullable: false,
        default: true,
        name: 'is_active'
    })
    isActive: boolean;

    @CreateDateColumn({
        name: 'created_at',
        type: 'datetime'
    })
    createdAt: Date;

    @Column('varchar', {
        nullable: true,
        name: 'created_user'
    })
    createdUser: string | null;

    @UpdateDateColumn({
        name: 'updated_at',
        type: 'datetime'
    })
    updatedAt: Date;

    @Column('varchar', {
        nullable: true,
        name: 'updated_user'
    })
    updatedUser: string | null;

    @VersionColumn({
        default: 1,
        name: 'version_flag'
    })
    versionFlag: number;
}